import { useEffect, useRef } from 'react';

const BottomDialog = ({
  dialogRef,
  closeDialog,
  children,
  closeButton = false,
}) => {
  const bottomRef = useRef(null);

  useEffect(() => {
    const clickOutsideDialog = (e) => {
      if (
        dialogRef.current.contains(e.target) &&
        !bottomRef.current.contains(e.target)
      ) {
        closeDialog();
      }
    };

    document.addEventListener('click', clickOutsideDialog);

    return () => {
      document.removeEventListener('click', clickOutsideDialog);
    };
  }, []);

  return (
    <dialog
      ref={dialogRef}
      className='w-full h-full max-w-lg max-h-full bg-transparent'
      onCancel={closeDialog}
    >
      <div
        ref={bottomRef}
        className={`bg-white fixed bottom-0 w-full max-w-lg rounded-t-3xl px-3 pb-6 ${
          closeButton ? 'pt-6' : 'pt-10'
        }`}
      >
        {closeButton && (
          <div className='text-right text-xl mb-4'>
            <span onClick={closeDialog}>🅧</span>
          </div>
        )}
        {children}
      </div>
    </dialog>
  );
};

export default BottomDialog;
